<template>
    <div id="main">
        <div class="page page-container">
            <h1 class="title">{{ $t("geonalise-por-ocorrencia") }}</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a>{{ $t("agro") }}</a>
                    </li>
                    <li>
                        <a>{{ $t("geoanalise") }}</a>
                    </li>
                    <li>
                        <a href="#" aria-current="page">{{
                            $t("geonalise-por-ocorrencia")
                        }}</a>
                    </li>
                </ul>
            </nav>

            <!-- ABAS -->
            <ul
                class="nav nav-tabs nav-tabs-children"
                key="geoanalise-por-ocorrencia"
            >
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    v-show="permissao.read"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">
                        <span
                            v-if="aba.icone"
                            class="icon"
                            :style="{ color: aba.cor }"
                        >
                            <i :class="aba.icone.toLowerCase()" />
                        </span>
                        {{
                            $t(aba.descricao)
                                ? $t(aba.descricao)
                                : aba.descricao
                        }}
                    </a>
                </li>
            </ul>

            <!-- CONJUNTO DE ABAS - MOBILE -->
            <b-dropdown
                aria-role="list"
                class="mobile-tab-list"
                key="agro-fenologia-manage-mobile"
            >
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        <span
                            v-if="abas[abaSelecionada].icone"
                            class="icon"
                            :style="{ color: abas[abaSelecionada].cor }"
                        >
                            <i
                                :class="
                                    abas[abaSelecionada].icone.toLowerCase()
                                "
                            />
                        </span>
                        {{
                            $t(abas[abaSelecionada].descricao)
                                ? $t(abas[abaSelecionada].descricao)
                                : abas[abaSelecionada].descricao
                        }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    v-show="permissao.read"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{
                        $t(aba.descricao)
                            ? $t(aba.descricao)
                            : aba.descricao
                    }}
                </b-dropdown-item>
            </b-dropdown>

            <div class="abas">
                <Mapa
                    ref="tabMapa"
                    v-if="abasAbertas[0]"
                    v-show="abas[abaSelecionada].id == 0"
                    :filtro="filtro"
                    @carregadoDados="recuperaDados"
                />

                <DetalharDados
                    ref="tabDetalharDados"
                    v-if="abasAbertas[1]"
                    v-show="abas[abaSelecionada].id == 1"
                    :filtro="filtro"
                    :dadosMapa="dadosMapa"
                />
            </div>
        </div>
    </div>
</template>

<script>
// Abas
import DetalharDados from "@/components/agro/geoanalise/geoanalise-por-ocorrencia/abas/DetalharDados.vue";
import Mapa from "@/components/agro/geoanalise/geoanalise-por-ocorrencia/abas/Mapa.vue";

export default {
    components: {
        Mapa,
        DetalharDados,
    },
    data() {
        return {
            abaSelecionada: 0,
            abas: [
                {
                    id: 0,
                    descricao: "mapa",
                },
                {
                    id: 1,
                    descricao: "detalhar-dados",
                },
            ],
            abasAbertas: {
                changeTab(i) {
                    this.abaSelecionada = i;
                    this.abasAbertas[this.abas[this.abaSelecionada].id] = true;
                },
            },
            filtro: {
                inicio: null,
                fim: null,
                safras: [],
                culturas: [],
                clientes: []
            },
            permissao: false,
            dadosMapa: [],
            clients: [],
        };
    },
    methods: {
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada].id] = true;
        },
        recuperaDados(data, clients){
            this.dadosMapa = data;
            this.filtro.clientes = clients;
        }
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "agro",
            "geoanalise",
            "mapa-geoanalise-por-ocorrencia"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "mapa-geoanalise-por-ocorrencia" },
            });
        }
        this.changeTab(0)
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0px 20px;
    height: 100%;
}

.page {
    position: relative;
    height: auto;
}

.abas {
    height: 100%;
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}
</style>